export default {
  USD: "$",
  JPY: "¥",
  CDA: "C$",
};
